import {Box, Grid, Modal, Popover, Typography} from '@mui/material';
import React, {useContext, useState} from 'react';
import {makeStyles} from 'tss-react/mui';
import {AppContext} from '@/utils/appContext';
import {useTranslation} from 'react-i18next';
import {ModalDestinationPicker} from '../modal/ModalDestinationPicker';
import {MapNavigation} from '@vectopus/atlas-icons-react';
import {useResponsive} from '@/hooks/use-responsive';
import {website} from "@/utils/helpers";
import {ModalDestinationPickerVP} from "@/components/step1/modal/ModalDestinationPickerVP";

const SelectDestinationField = (props: any) => {
  const useStyles = makeStyles()((theme) => {
    return {
      fieldContent: {
        backgroundColor: '#f0f0f0',
        position: 'relative',
        padding: '16px 12px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderRadius: theme.radius.formBorderRadius,
        cursor: 'pointer',
        i: {
          fontSize: 26
        },
        [theme.breakpoints.down('md')]: {
          justifyContent: 'space-between',
          backgroundColor: '#fff'
        },
        [theme.breakpoints.only('sm')]: {
          justifyContent: 'space-between'
        }
      },
      fieldContentSearchBarMobile: {
        backgroundColor: '#f0f0f0',
        padding: '16px 12px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderRadius: theme.radius.formBorderRadius,
        cursor: 'pointer',
        i: {
          fontSize: 26
        },
        [theme.breakpoints.down('md')]: {
          justifyContent: 'space-between',
          backgroundColor: '#fff',
          alignItems: 'flex-end',
          svg: {
            paddingLeft: 10,
          }
        },
        [theme.breakpoints.only('sm')]: {
          justifyContent: 'center'
        }
      },
      selectedWhere: {
        color: '#000!important',
        fontFamily: theme.typography.body1.fontFamily
      },
      inputPaper: {
        /*width: '100%!important',
        maxWidth: '100%!important',*/
        backgroundColor: '#FFF',
        borderRadius: theme.radius.formBorderRadius,
        h6: {
          fontSize: 14,
          /*fontFamily: theme.typography.h2.fontFamily,*/
          color: '#9B9B9B'
        },
        '.las.la-arrow-right': {
          color: '#9B9B9B'
        }
      },
      inputPaperMobileBar: {
        '& i': {
          display: 'none'
        },
        '.MuiBox-root': {
          padding: '0!important',
          h6: {
            textDecoration: 'underline',
            fontFamily: theme.typography.body1.fontFamily
          }
        }
      },
      popoverContainer: {
        '.MuiPopover-paper': {
          width: 400,
          height: 'auto'
        },
        '& .MuiBackdrop-root': {
          backgroundColor: '#000000',
          opacity: '0.4!important'
        }
      }
    };
  });

  const modal = {
    backgroundColor: '#FFF',
    '.MuiBackdrop-root': {
      backgroundColor: '#FFF'
    }
  };

  const modalInsideDrawer = {
    width: 470,
    left: 'inherit',
    backgroundColor: '#FFF',
    overflow: 'scroll',
    '.MuiBackdrop-root': {
      display: 'none!important'
    }
  }

  const appContext = useContext(AppContext);
  const {classes} = useStyles();
  const {t} = useTranslation();

  const [openModalDestinationPicker, setOpenModalDestinationPicker] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
    setOpenModalDestinationPicker(true);
  };
  const handleCloseModalDestinationPicker = () => {
    setOpenModalDestinationPicker(false);
  }

  const upMd = useResponsive('up', 'md');
  const downMd = useResponsive('down', 'md');

  const container = props.params.container;

  return (
    <>
      <Grid
        size={{ sm: "auto", md: 3 } as const}
        id={'destinationSearchField'}
        className={
          props.params && props.params.container === 'SearchBarMobile'
            ? classes.inputPaperMobileBar
            : classes.inputPaper
        }
        onClick={(event: any) => handlePopoverOpen(event)}
        sx={{ width: container === "DrawerSearchWidget" ? "100%!important" : "initial" }}
      >
        <Box
          id={'fieldContent'}
          className={
            props.params && props.params.container === 'SearchBarMobile'
              ? classes.fieldContentSearchBarMobile
              : classes.fieldContent
          }>
          {
            upMd && container !== 'DrawerSearchWidget' && (
              <Box pr={1} sx={{ height: 24 }}>
                <MapNavigation size={20}/>
              </Box>
            )
          }
          <Typography
            variant={'h6'}
            component={'h6'}
            sx={{textAlign: {sm: 'center'}, whiteSpace: 'nowrap'}}
            className={
              appContext.searchForms[appContext.orderIndex].destination !== '' ||
              appContext.searchForms[appContext.orderIndex].property !== '' ||
              appContext.searchForms[appContext.orderIndex].landscape !== '' ||
              appContext.searchForms[appContext.orderIndex].typeOfHoliday !== ''
                ? classes.selectedWhere
                : ''
            }
          >
            {
              upMd && (
                  <>
                    {appContext.searchForms[appContext.orderIndex].property !== '' &&
                       //  t(appContext.searchForms[appContext.orderIndex].property)}
                      appContext.properties.find( property => property.code === appContext.searchForms[appContext.orderIndex].property )?.propertyInfo?.title
                    }
                  </>
                )
            }

            {
              downMd && website.properties.length !== 1 && (
                <>
                  {appContext.searchForms[appContext.orderIndex].property !== '' && appContext.properties.find( property => property.code === appContext.searchForms[appContext.orderIndex].property )?.propertyInfo?.title
                  }
                </>
              )
            }

            {appContext.searchForms[appContext.orderIndex].destination !== '' &&
              appContext.searchForms[appContext.orderIndex].property === '' &&
              t(appContext.searchForms[appContext.orderIndex].destination)}

            {appContext.searchForms[appContext.orderIndex].destination === '' &&
              appContext.searchForms[appContext.orderIndex].property === '' &&
              appContext.searchForms[appContext.orderIndex].landscape !== '' &&
              t(appContext.searchForms[appContext.orderIndex].landscape)}

            {appContext.searchForms[appContext.orderIndex].destination === '' &&
              appContext.searchForms[appContext.orderIndex].property === '' &&
              appContext.searchForms[appContext.orderIndex].landscape === '' &&
              t('step1_tour_description')}
          </Typography>

          {
            container === 'DrawerSearchWidget' && (
              <Box pr={1} sx={{ position: 'absolute', right: 5, display: 'flex', alignItems: 'center' }}>
                <MapNavigation size={20}/>
              </Box>
            )
          }
        </Box>
      </Grid>

      {
        upMd && container === 'DrawerSearchWidget' && (
          <Modal
            open={openModalDestinationPicker}
            onClose={handleCloseModalDestinationPicker}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={modalInsideDrawer}>
            <>
              <ModalDestinationPicker
                params={{
                  container,
                  openModalDestinationPicker,
                  handleCloseModalDestinationPicker
                }}
              />
            </>
          </Modal>
        )
      }

      {
        downMd && (
          <Modal
              open={openModalDestinationPicker}
              onClose={handleCloseModalDestinationPicker}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              sx={modal}>
            <>
              {
                website.code === 'VP' ? (
                  <ModalDestinationPickerVP
                    params={{
                      container,
                      openModalDestinationPicker,
                      handleCloseModalDestinationPicker
                    }}
                  />
                ) : (
                  <ModalDestinationPicker
                    params={{
                      container,
                      openModalDestinationPicker,
                      handleCloseModalDestinationPicker
                    }}
                  />
                )
              }
            </>
          </Modal>
        )
      }

      {
        upMd && container !== 'DrawerSearchWidget' && (
          <Popover
              onClose={handleCloseModalDestinationPicker}
              open={openModalDestinationPicker}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              className={classes.popoverContainer}>
            <>
              {
                website.code === 'VP' ? (
                  <ModalDestinationPickerVP
                    params={{
                      container,
                      openModalDestinationPicker,
                      handleCloseModalDestinationPicker
                    }}
                  />
                ) : (
                  <ModalDestinationPicker
                    params={{
                      container,
                      openModalDestinationPicker,
                      handleCloseModalDestinationPicker
                    }}
                  />
                )
              }
            </>
          </Popover>
        )
      }
    </>
  );
};

export default SelectDestinationField;
